export default "__VITE_ASSET__Ds5$YLgr__"